<script>
import { mapActions, mapState } from "vuex";
import PrefectureList from "@/mixins/PrefectureList";
export default {
  name: "ChooseTraderModal",
  components: {},
  mixins: [PrefectureList],
  props: {
    enable: {
      type: Boolean,
      default: false,
    },
    /**
     * 検索種別
     * transport: 収運
     * trader: 処分
     * all: 全て
     */
    searchType: {
      type: String,
      default: () => "all",
    },
    /**
     * 非表示を除く
     */
    withoutInvisible: {
      type: Boolean,
      default: () => false,
    },
    /**
     * 報告不要を除く
     */
    withoutNonReporting: {
      type: Boolean,
      default: () => false,
    },
    /**
     * 未加入を除く
     */
    withoutNonSubscribe: {
      type: Boolean,
      default: () => false,
    },
    /**
     * 一般廃棄物処分業者を含む
     */
    includeGeneralWasteDisposer: {
      type: Boolean,
      default: () => false,
    },
    includeFinalDisposer: {
      type: Boolean,
      default: () => false,
    },
    ownDisposer: {
      type: Boolean,
      default: () => false,
    },
    /**
     * 再資源 許可番号登録済のみ(報告不要, 未加入に適用する条件)
     */
    permitNumberRegisteredOnly: {
      type: Boolean,
      default: false,
    },
    /**
     * 事業場未登録の事業者を含む
     */
    withNoneLocation: {
      type: Boolean,
      default: false,
    }

  },
  data() {
    return {
      page: 1,
      totalVisible: 7,
      traders: [],
      choseTrader: null,
      modalTitle: null,
      searchForm: {
        subscriber_no: null,
        query: null,
        billing_address_name: null,
        prefecture_code: null,
        address: null,
      },
      pagination: {
        current_page: 1,
        total_count: 0,
      },
      tableHeaders: [
        { value: "subscriber_number", text: "加入者番号", width: "10%" },
        { value: "name", text: "運搬先名", width: "50%" },
        { value: "address", text: "住所", width: "40%" },
      ],
    };
  },
  computed: {
    ...mapState("DriverTenantConfiguration", {
      useBilling: "use_billing",
    }),
  },
  watch: {
    enable(value) {
      this.traders = [];
      this.choseTrader = null;
      this.page = 1;
      Object.assign(this.$data.searchForm, this.$options.data().searchForm);
      Object.assign(this.$data.pagination, this.$options.data().pagination);
      if (this.choseRow) {
        this.choseRow.select(false);
        this.choseRow = null;
      }
      this.setTitle();
      if (value) {
        this.searchTraders();
      }
    },
  },
  created() {},
  methods: {
    ...mapActions("DriverMasterSearchTraderMember", {
      fetchTraderMembers: "index",
    }),
    searchButtonClickEvent() {
      this.page = 1
      this.searchTraders();
    },
    closeButtonClickEvent() {
      this.$emit("close");
    },
    registerButtonClickEvent() {
      this.$emit("selected", this.choseTrader);
    },
    pageChangeEvent() {
      this.searchTraders()
    },
    setTitle() {
      if (this.searchType === "transport") {
        this.modalTitle = "収運業者から選択";
      } else if (this.searchType === "trader") {
        this.modalTitle = "処分業者から選択";
      } else {
        this.modalTitle = "収運・処分業者から選択";
      }
    },
    rowClickEvent(item, row) {
      this.choseTrader = item;
      this.choseTrader.type = "Trader";
      this.choseRow = row;
      row.select(true);
    },
    /**
     * 事業者行 ダブルクリックイベント
     * @param $event { MouseEvent }
     * @param row { Object } 行
     */
    rowDoubleClickEvent($event, row) {
      this.$emit("selected", row.item);
    },

    searchTraders() {
      let params = {
        ...this.searchForm,
        without_invisible: this.withoutInvisible,
        without_non_reporting: this.withoutNonReporting,
        without_non_subscribe: this.withoutNonSubscribe,
        include_general_waste_disposer: this.includeGeneralWasteDisposer,
        include_final_disposal: this.includeFinalDisposer,
        own_disposer: this.ownDisposer,
        search_type: this.searchType,
        permit_number_registered_only: this.permitNumberRegisteredOnly,
        with_none_location: this.withNoneLocation,
        limit: 10,
        page: this.page,
      };
      this.fetchTraderMembers({ params: params }).then((content) => {
        this.traders = content.traders;
        this.pagination = content.pagination;
      });
    },
  },
};
</script>

<template>
  <div>
    <v-dialog
      v-model="enable"
      persistent
      width="900"
      scrollable
      @keydown.esc="closeButtonClickEvent"
      @close="closeButtonClickEvent"
    >
      <v-card>
        <v-toolbar flat>
          <v-toolbar-title>{{ modalTitle }}</v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text>
          <!-- 検索 -->
          <v-container>
            <v-row>
              <!-- 加入者番号, 名称 -->
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="searchForm.query"
                  dense
                  hide-details="auto"
                  label="事業者名・加入者番号"
                  clearable
                  outlined
                  persistent-placeholder
                  placeholder="部分一致で検索"
                  rounded
                  @blur="searchButtonClickEvent"
                />
              </v-col>
              <!-- /加入者番号, 名称 -->
              <!-- 請求先名 -->
              <v-col
                v-if="useBilling"
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="searchForm.billing_address_name"
                  dense
                  hide-details="auto"
                  label="請求先名"
                  clearable
                  outlined
                  persistent-placeholder
                  placeholder="部分一致で検索"
                  rounded
                  @blur="searchButtonClickEvent"
                />
              </v-col>
              <!-- /請求先名 -->
            </v-row>
            <v-row v-if="!useBilling">
              <!-- 都道府県コードのみ -->
              <v-col cols="12" md="3">
                <v-select
                  v-model="searchForm.prefecture_code"
                  :items="prefList"
                  clearable
                  dense
                  hide-details="auto"
                  label="都道府県"
                  outlined
                  persistent-placeholder
                  placeholder="例）東京都"
                  rounded
                  @change="searchButtonClickEvent"
                />
              </v-col>
              <!-- /都道府県コードのみ -->
              <!-- 町域・詳細住所 -->
              <v-col cols="12" md="9">
                <v-text-field
                  v-model="searchForm.address"
                  dense
                  label="市区町村・町域・詳細住所"
                  hide-details="auto"
                  outlined
                  persistent-placeholder
                  placeholder="例）中央区日本橋兜町１－２－３○○ビル○階"
                  rounded
                  @blur="searchButtonClickEvent"
                />
              </v-col>
            </v-row>

            <v-card-actions>
              <v-spacer />
              <v-btn color="primary" @click="searchButtonClickEvent">
                <v-icon>mdi-magnify</v-icon>&nbsp;検索
              </v-btn>
            </v-card-actions>
          </v-container>
          <!-- /検索 -->

          <!-- 一覧 -->
          <v-data-table
            :headers="tableHeaders"
            :items="traders"
            :items-per-page="-1"
            disable-sort
            single-select
            hide-default-footer
            @click:row="rowClickEvent"
            @dblclick:row="rowDoubleClickEvent"
          >
            <!-- 取引先名 -->
            <template v-slot:[`item.name`]="{ item }">
              <div style="display: flex; align-items: center; gap: 4px;">
                <v-img
                  v-if="item.use_station"
                  max-height="18"
                  max-width="18"
                  :src="require(`@/assets/images/DXE_mark.svg`)"
                />
                <div style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                  <span :title="item.name">{{ item.name }} </span>
                </div>
                <v-tooltip v-if="useBilling" top :open-on-hover="false">
                  <template #activator="{ on }">
                    <v-btn
                      icon
                      small
                      retain-focus-on-click
                      @click="on.click"
                      @blur="on.blur"
                    >
                      <v-icon small> mdi-map-marker-outline </v-icon>
                    </v-btn>
                  </template>
                  <div
                    :title="item.address"
                    class="ellipsis-text"
                    style="max-width: 250px; width: initial; font-size: 85%"
                  >
                    {{ item.address }}
                  </div>
                </v-tooltip>
              </div>
            </template>
            <!-- /取引先名 -->
            <!-- 請求先名 -->
            <template
              v-if="useBilling"
              v-slot:[`item.billing_address_name`]="{ item }"
            >
              <div
                v-if="item.billing_address"
                :title="item.billing_address.name"
                class="ellipsis-text"
                style="width: 250px; font-size: 85%; display: inline-block"
              >
                {{ item.billing_address.name }}
              </div>
            </template>
            <!-- /請求先名 -->
            <!-- 住所 -->
            <template v-if="!useBilling" v-slot:[`item.address`]="{ item }">
              <span
                v-if="item.address"
                :title="item.address"
                class="ellipsis-text"
                style="max-width: 250px; width: initial; font-size: 85%"
              >
                {{ item.address }}
              </span>
            </template>
            <!-- /住所 -->
          </v-data-table>
          <!-- /一覧 -->
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-row dense>
            <v-col>
              <v-pagination
                v-model="page"
                :length="pagination.total_pages"
                :total-visible="totalVisible"
                circle
                prev-icon="mdi-menu-left"
                next-icon="mdi-menu-right"
                @input="pageChangeEvent"
              />
            </v-col>
          </v-row>
        </v-card-actions>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="closeButtonClickEvent" @mousedown.prevent>
            閉じる
          </v-btn>
          <v-btn
            :disabled="!choseTrader"
            class="primary"
            @click="registerButtonClickEvent"
          >
            反映
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
